import { Routes, Route } from 'react-router-dom'
import Clients from './index/Clients'
import ClientForm from './form/ClientForm'
import ClientView from './show/ClientView'
import { useStateContext } from 'context/ContextProvider'
import { Role } from 'types'
import Page404 from 'views/errors/Page404'

const ClientsRoutes = () => {

  const { user } = useStateContext();

  if( ![Role.Admin,Role.Advisor,Role.Manager,Role.Accounting].some(value => user?.roles.includes(value))){
    return <Page404 />
  }

  
  return (
    <Routes>
      <Route path="/">
        <Route
          index
          element={<Clients />}
        />
        <Route
          path="new"
          element={<ClientForm key="clientCreate" />}
        />
        <Route
          path=":id"
          element={<ClientForm key="clientUpdate" />}
        />
        <Route
          path="view/:id"
          element={<ClientView key="clientView" />}
        />
      </Route>
    </Routes>
  )
}

export default ClientsRoutes
